import { http } from "../utils/http";

export const notificationApi = async (data) => {
  try {
    const res = await http.get("/Notifications/list", {
      params: data,
    });
    return res;
  } catch (error) {}
};
